export default function formatFileDuration(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = Math.round(totalSeconds % 60)

  const parts: string[] = []

  if (hours > 0) {
    parts.push(`${hours}h`)
  }

  if (minutes > 0 || (hours > 0 && seconds > 0)) {
    parts.push(`${minutes}min`)
  }

  if (seconds > 0) {
    parts.push(`${seconds}s`)
  }

  // If all are zero, show "0s"
  if (parts.length === 0) {
    return '0s'
  }

  return parts.join(' ')
}
